module.exports = __webpack_public_path__ + "img/email.6d6fa5cc.svg";